import React, {Component} from 'react';

//css
import styles from '../../../static/css/componentStyleModules/inputComponentStyleModules/memberIconSelectComponent.module.scss'
import FaceIconBaseComponent from '../../faceIconComponents/FaceIconBaseComponent';

export default class MemberIconSelectComponent extends Component {

    constructor(props){
        super(props);
        this.state = {

            tabMode:'headMode',

            headList:[
                {key:'basic',name_ja:'きほん'},
                {key:'tearDropHair',name_ja:'ホイップ'},
                {key:'twinTail',name_ja:'ガール'},
                {key:'sevenThree',name_ja:'シチサン'},
                {key:'devil',name_ja:'アクマ'},
                {key:'cat',name_ja:'ねこ'},
            ],

            eyesList:[
                {key:'basic',name_ja:'きほん'},
                {key:'eyelashes',name_ja:'まつげ'},
                {key:'slanted',name_ja:'つりめ'},
                {key:'drooping',name_ja:'たれめ'},
                {key:'narrowSlanted',name_ja:'ほそつりめ'},
                {key:'narrowDrooping',name_ja:'ほそたれめ'},
                {key:'glasses',name_ja:'めがね'},
            ],

            eyeblowsList:[
                {key:'none',name_ja:'なし'},
                {key:'slanted',name_ja:'つりまゆ'},
                {key:'drooping',name_ja:'たれまゆ'},
            ],

            mouthList:[
                {key:'basic',name_ja:'きほん'},
                {key:'grin',name_ja:'くちあけ'},
                {key:'monkey',name_ja:'さるぐち'},
                {key:'smirk',name_ja:'にやり'},
                {key:'pouty',name_ja:'たらこ'},
                {key:'fanged',name_ja:'キバ'},
                {key:'cat',name_ja:'ねこぐち'},
            ],

            colorList:[
                {key:'vermilion', hsl:'hsl(6,77%,62%)'},
                {key:'yellow', hsl:'hsl(53,58%,60%)'},
                {key:'limeGreen', hsl:'hsl(88,47%,57%)'},
                {key:'emelald', hsl:'hsl(158,47%,58%)'},
                {key:'skyBlue', hsl:'hsl(188,47%,62%)'},
                {key:'blue', hsl:'hsl(212,60%,65%)'},
                {key:'fuji', hsl:'hsl(247,56%,75%)'},
                {key:'purple', hsl:'hsl(329,47%,67%)'},
                {key:'sakura', hsl:'hsl(351,72%,78%)'},
            ],

            selectedHead:'basic',
            selectedEyes:'basic',
            selectedEyesblow:'none',
            selectedColor:'#666666',

            inIconAnimation:false,

        }
    }

    componentWillMount = () => {
        this.setState({
            selectedHead:this.props.memberData.head,
            selectedEyes:this.props.memberData.eyes,
            selectedEyeblows:this.props.memberData.eyeblows,
            selectedMouth:this.props.memberData.mouth,
            selectedColor:this.props.memberData.color,
        })
    }

    componentDidMount = () => {
        process.nextTick(() => {
            this.refs.memberIconSelectArea.classList.remove(styles['hidden']);
        })
    }

    selectValue = (value) => {
        if(this.state.inIconAnimation){
            //アニメーション中なら、一旦止めてすぐ再開させる
            this.setState({inIconAnimation:false});
            process.nextTick(() => {
                this.setState({inIconAnimation:true});
            })
            
        }else{
            this.setState({inIconAnimation:true});
        }

        setTimeout(() => {
            if(this.state.tabMode === 'headMode'){
                this.setState({selectedHead:value});
            }else if(this.state.tabMode === 'eyesMode'){
                this.setState({selectedEyes:value});
            }else if(this.state.tabMode === 'eyeblowsMode'){
                this.setState({selectedEyeblows:value});
            }else if(this.state.tabMode === 'mouthMode'){
                this.setState({selectedMouth:value});
            }else if(this.state.tabMode === 'colorMode'){
                this.setState({selectedColor:value});
            }
        },200)

    }

    render() {
        const mainIconClass = () => {
            if(this.state.inIconAnimation){
                setTimeout(() => {
                    this.setState({inIconAnimation:false});
                },500)
                return styles['memberIcon'] + ' ' + styles['inAnimation'];
            }else{
                return styles['memberIcon'];
            }
        }

        const iconGrid = (parts) => {
            return (
              <div className={styles['iconGrid'] + ' touchActivePush'} key={parts.key}
              onClick={() => this.selectValue(parts.key)}>
                <div className={styles['iconParts']}>
                  <FaceIconBaseComponent 
                  head={this.state.tabMode === 'headMode' ? parts.key : 'basic'}
                  eyes={this.state.tabMode === 'eyesMode' ? parts.key : 'none'}
                  eyeblows={this.state.tabMode === 'eyeblowsMode' ? parts.key : 'none'}
                  mouth={this.state.tabMode === 'mouthMode' ? parts.key : 'none'}
                  fillColor={this.props.memberData.color}
                  />
                </div>
                <p>{parts.name_ja}</p>
              </div>
          )
        }

        const colorGrid = (color) => {
            return (
                <div className={styles['iconGrid'] + ' touchActivePush'} key={color.hsl}
                onClick={() => this.selectValue(color.hsl)}>
                <div className={styles['colorParts']} style={{backgroundColor:color.hsl}}>
                  </div>
                </div>
            )
        }

        return (
            <div className={styles['memberIconSelectArea'] + ' ' + styles['hidden']} ref="memberIconSelectArea">

              <div className={styles['currentIconDisplayBase']}>
                <div className={styles['currentIconDisplayArea']}>
                  <div className={mainIconClass()}>
                    <FaceIconBaseComponent
                    head={this.state.selectedHead}
                    eyes={this.state.selectedEyes}
                    eyeblows={this.state.selectedEyeblows}
                    mouth={this.state.selectedMouth}
                    fillColor={this.state.selectedColor}
                    />
                  </div>
                </div>
              </div>

              <div className={styles['iconSelectWindowArea']}> 

                <div className={styles['iconSelectButtonArea']}>
                  <div className="touchActiveDark"
                  onClick={() => this.props.onCancelClick()}>キャンセル</div>
                  <div className="touchActiveDark"
                  onClick={() => this.props.onEnterClick(
                      this.state.selectedHead,
                      this.state.selectedEyes,
                      this.state.selectedEyeblows,
                      this.state.selectedMouth,
                      this.state.selectedColor
                  )}
                  >OK</div>
                </div>

                <div className={styles['iconSelectTabArea']}>
                  <div className={this.state.tabMode === 'headMode' 
                  ? styles['selected']  + ' touchActiveDark' : 'touchActiveDark'}
                  onClick={() => this.setState({tabMode:'headMode'})} >あたま</div>
                  <div className={this.state.tabMode === 'eyesMode' 
                  ? styles['selected']  + ' touchActiveDark' : 'touchActiveDark'}
                  onClick={() => this.setState({tabMode:'eyesMode'})} >め</div>
                  <div className={this.state.tabMode === 'eyeblowsMode' 
                  ? styles['selected']  + ' touchActiveDark' : 'touchActiveDark'}
                  onClick={() => this.setState({tabMode:'eyeblowsMode'})} >まゆ</div>
                  <div className={this.state.tabMode === 'mouthMode' 
                  ? styles['selected']  + ' touchActiveDark' : 'touchActiveDark'}
                  onClick={() => this.setState({tabMode:'mouthMode'})} >くち</div>
                  <div className={this.state.tabMode === 'colorMode' 
                  ? styles['selected']  + ' touchActiveDark' : 'touchActiveDark'}
                  onClick={() => this.setState({tabMode:'colorMode'})} >色</div>
                </div>

                <div className={styles['iconSelectGridArea']}>
                  {this.state.tabMode === 'headMode' ? this.state.headList.map(iconGrid) : null}
                  {this.state.tabMode === 'eyesMode' ? this.state.eyesList.map(iconGrid) : null}
                  {this.state.tabMode === 'eyeblowsMode' ? this.state.eyeblowsList.map(iconGrid) : null}
                  {this.state.tabMode === 'mouthMode' ? this.state.mouthList.map(iconGrid) : null}
                  {this.state.tabMode === 'colorMode' ? this.state.colorList.map(colorGrid) : null}
                </div>
              </div>

            </div>
        )
    }

};